import { useContext } from "react";

import { CoreContext } from "../../context/global/CoreContext";

import { Button } from "../ui";

/**
 * NotAuthorized component to inform the user they cannot access the page.
 *
 * @component
 * @returns {JSX.Element} The rendered NotAuthorized component.
 */
const NotAuthorized = () => {
  const { baseURL } = useContext(CoreContext);

  return (
    <div className="font-inter caret-transparent">
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h1 className="text-4xl font-bold mb-4">Access Denied</h1>
        <h2 className="text-xl mb-6">
          You do not have the necessary permissions to view this page.
        </h2>
        <p className="text-md mb-6">
          If you believe this is an error, please contact the office.
        </p>
        <Button
          text="Return to Home"
          variant="primary"
          onClick={() => (window.location.href = baseURL)}
        />
      </div>
    </div>
  );
};

export default NotAuthorized;
